import { FloatingFooter } from '@fabric-app/ui/components/FloatingFooter';
import type React from 'react';
import { IconNavigational24FabricFace, IconNavigational24Search } from '@fabric-app/icons/svg';
import { useAssistantStore } from '@fabric-app/business/assistant/stores/assistantStore';
import { useSearchOverlay } from '@fabric-app/business/search/hooks/useSearchOverlay';

export const PublishedFooter: React.FC<{ rootFolderId: string }> = ({ rootFolderId }) => {
  const { setChatAssistantOpen } = useAssistantStore();
  const { openOverlay } = useSearchOverlay();

  return (
    <FloatingFooter.Container key="footer-desktop" alwaysFloating>
      <FloatingFooter.Button
        aria-label="Search"
        onClick={() => {
          openOverlay('location', {
            forcedAncestorId: rootFolderId,
          });
        }}
        shape="square"
      >
        <IconNavigational24Search />
      </FloatingFooter.Button>
      <FloatingFooter.Button
        aria-label="Assistant"
        onClick={() => {
          setChatAssistantOpen(true);
        }}
        shape="square"
      >
        <IconNavigational24FabricFace />
      </FloatingFooter.Button>
    </FloatingFooter.Container>
  );
};
